import React from 'react';
import Hero from '../components/home/Hero';
import StatsRow from '../components/home/StatsRow';
import HowItWorks from '../components/home/HowItWorks';
import WhereWeDrive from '../components/home/WhereWeDrive';
import Reviews from '../components/home/Reviews';
import CtaBanner from '../components/home/CtaBanner';

function Home() {
  return (
    <main id="main">
      <Hero />
      <StatsRow />
      <HowItWorks />
      <WhereWeDrive />
      <Reviews />
      <CtaBanner />
    </main>
  );
}

export default Home;
